<template>
  <div></div>
</template>

<script>
export default {
  name: "Cart"
}
</script>

<style scoped>

</style>
